import { AxiosError } from 'axios';

type XlsxError = {
    message: string;
    errors?: { message: string; sheet: string; row?: string; field?: string }[];
};

export const extractXlsxErrors = (error: Error) => {
    if (error instanceof AxiosError) {
        return error.response?.data as XlsxError;
    }
    return { message: error.message };
};
